<template>
    <tbody>
    <tr>
        <td>
            <date-input v-model="innerPeriod.startOfPeriod"
                        v-field-control.required="{type:'date', name:'startOfPeriod' + index}"
                        :disabled="index === 0"
                        required
                        :emit="true"
                        @input="updateNextPeriod"
            ></date-input>
        </td>
        <td>
            <date-input v-model="innerPeriod.endOfPeriod"
                        v-field-control.required="{type:'date', name:'endOfPeriod' + index}"
                        required
                        :emit="true"
                        @input="updateNextPeriod"
            ></date-input>
        </td>
        <td>
            <select v-model="innerPeriod.employmentType" @change="updatePeriod()">
                <option value="employed">Employed</option>
                <option value="self_employed">Self-employed</option>
                <option value="part_employed">Part-employed</option>
            </select>
        </td>
        <td>
            <div class="a-form-inputs--pound">
                <input autocomplete="off" type="number" v-model.number="innerPeriod.employmentIncome"
                       v-field-control.required="{type:'number', name:'employmentIncome' + index}"
                       v-on:focus="innerPeriod.employmentIncome = innerPeriod.employmentIncome || ''"
                       v-on:blur="innerPeriod.employmentIncome = innerPeriod.employmentIncome || 0"
                       v-two-dp
                       required
                       @input="updatePeriod()">
            </div>
        </td>
        <td>
            <control
                    tip-text="ASHE Data are gross median figures. Therefore the Net function has been disabled. To re-enable edit the employment income figure."
                    tip-icon="info"
                    tip-side="left"
                    tip-width="250"
                    tip-name="future_losses_constant"
                    :tipShow="disabledNetGross"
                    :table-control="true">
                <select v-model="innerPeriod.employmentNetGross" @change="updatePeriod()" :disabled="disabledNetGross">
                    <option value="net">Net</option>
                    <option value="gross">Gross</option>
                </select>
            </control>
        </td>
        <td>
            <div class="a-form-inputs--pound">
                <input autocomplete="off" type="number" v-model.number="innerPeriod.totalNetIncome" v-two-dp disabled>
            </div>
        </td>
        <td>
            <button class="a-button u-no-margin ashe p-pi-income__ashe-average-button" @click="selectSalary(null)">
                Use ASHE average
            </button>
        </td>
        <td>
            <button class="a-button u-no-margin refine" @click="openDialog">
                Refine by occupation
            </button>
        </td>
        <td v-if="this.index === 0">
            <button class="a-button a-button--delete a-button--delete-disabled a-button--small" role="button" type="button" disabled="disabled"></button>
        </td>
        <td v-else>
            <button class="a-button a-button--delete a-button--small" role="button" type="button" @click="deletePeriod"></button>
        </td>
    </tr>
    <tr class="a-table--error" v-if="!startOfPeriodRules || !endOfPeriodRules || !rangeOfPeriodRules || !incomeRules">
        <td colspan="9">
            <control-error :show="!startOfPeriodRules">
                The income period start date must be a valid date, can not be before the claimant's date of injury and
                cannot be after the claimants's retirement date/end of future losses date
            </control-error>
            <control-error :show="!endOfPeriodRules">
                The income period end date must be a valid date, can not be before claimant's date of injury and
                cannot be after the claimants's retirement date/end of future losses date
            </control-error>
            <control-error :show="!rangeOfPeriodRules">
                The income period start date must be before the income period end date
            </control-error>
            <control-error :show="!incomeRules">
                The total income per annum is required and must be £0 or greater
            </control-error>
        </td>
    </tr>
    <modal :name="'ons_salary_'+this.uniqueId" no-default-button="true">
        <div class="p-day-one__refine-occupation">
            <h2>Refine by occupation</h2>

            <div v-if="selectedNode">
                <p>
                    Your current selection - <strong>{{ getLastNode().description }}</strong><br/>
                    <span v-if="getLastNode().code.length !== 3">Select a salary, expand down further or use the average salary for this whole group</span>
                    <span v-else>Select a salary or use the average salary for this whole group</span>
                </p>

                <button @click="unselectNode(selectedNode)" class="a-button a-button--small">Back</button>
                <button @click="selectSalary(selectedNode)" class="a-button a-button--small">Use average {{displaySalary(selectedNode)}}</button>
            </div>
            <div v-else>
                <p>
                    Select a salary or expand the group
                </p>
            </div>
            <div>
                <div>
                    <table class=" a-table__small a-table a-table--full-width">
                        <thead>
                        <tr>
                            <th>Code</th>
                            <th>Description</th>
                            <th>Salary</th>
                            <th width="30"></th>
                            <th width="30"></th>
                        </tr>
                        </thead>
                        <tbody v-if="loading">
                        <td colspan="5" style="text-align: center;"><div class="a-loader--table"></div></td>
                        </tbody>
                        <tbody v-else>
                        <tr v-for="node in nodes" class="selected--row">
                            <td>{{node.code}}</td>
                            <td>{{node.description}}</td>
                            <td>{{displaySalary(node)}}</td>
                            <td>
                                <button :disabled="node.code.length === 4" class="a-button a-button--small" @click.stop="selectNode(node)">
                                    Expand
                                </button>
                            </td>
                            <td>
                                <button v-if="node.salary!=='x'" class="a-button a-button--small" @click.stop="selectSalary(node, type)">
                                    Select
                                </button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </modal>
    </tbody>
</template>

<script>
    import moment from 'moment';
    import {mapActions, mapGetters} from 'vuex';
    import DateInput from 'components/form/control/DateInput.vue';
    import Control from 'components/form/Control.vue';
    import ControlError from 'components/form/control/Error.vue';
    import IncomePeriodMix from 'pages/lost-years-claims/steps/income/income-period.mixin';
    import FormValidator from 'components/form/validator/mixin';
    import TwoDecimalPlaces from 'directives/TwoDecimalPlaces';
    import {validDate} from 'components/form/validator/validations';
    import Api from 'services/Api';
    import Modal from 'components/modal/Modal';
    import CurrencyFormat from 'mixins/currencyFormat';

    export default {
        name: 'income-period',
        mounted() {
            this.updatePeriod();
        },
        data() {
            return {
                loading: false,
                nodes: [],
                selectedNode: null,
                selectedNodes: [],
                disabledNetGross: false
            }
        },
        watch: {
            ['periodEmploymentIncome'] () {
                this.disabledNetGross = false
            }
        },
        components: {
            DateInput,
            Control,
            ControlError,
            Modal
        },
        props: {
            startDisabled: {
                type: Boolean,
                required: false
            },
            retired: {
                type: Boolean,
                required: true
            },
            lossOfEarnings: {
                type: Boolean,
                required: true
            },
            index: {
                type: Number,
                default: 0
            },
            maxIndex: {
                type: Number,
                default: 0
            },
            type: {
                type: String,
                required: true
            }
        },
        mixins: [
            CurrencyFormat,
            IncomePeriodMix,
            FormValidator
        ],
        directives: {
            'two-dp': TwoDecimalPlaces
        },
        computed: {
            ...mapGetters('personal/claimant', [
                'claimant',
                'getIncomePeriod',
                'getClaimInfo'
            ]),
            ...mapGetters('personal/futureLosses', [
                'getLoss',
            ]),
            ...mapGetters('modal', ['modals']),
            isModalOpen() {
                let ons_salary = 'ons_salary_'+this.uniqueId;
                return this.modals && this.modals[ons_salary];
            },
            uniqueId() {
                return this._uid;
            },
            periodEmploymentIncome() {
                return this.innerPeriod.employmentIncome;
            },
            startOfPeriodRules() {
                if (!validDate(this.innerPeriod.startOfPeriod) || this.innerPeriod.startOfPeriod === '' || this.innerPeriod.startOfPeriod === null) {
                    return false;
                }
                if (moment(this.innerPeriod.startOfPeriod, 'DD/MM/YYYY').isBefore(moment(this.getClaimInfo('dateOfInjury'), 'DD/MM/YYYY'))) {
                    return false;
                }
                if (moment(this.innerPeriod.startOfPeriod, 'DD/MM/YYYY').isAfter(moment(this.endOfPeriod, 'DD/MM/YYYY'))) {
                    return false;
                }
                return true;
            },
            endOfPeriodRules() {
                if (!validDate(this.innerPeriod.endOfPeriod) || this.innerPeriod.endOfPeriod === '' || this.innerPeriod.endOfPeriod === null) {
                    return false;
                }
                if (moment(this.innerPeriod.endOfPeriod, 'DD/MM/YYYY').isBefore(moment(this.getClaimInfo('dateOfInjury'), 'DD/MM/YYYY'))) {
                    return false;
                }
                if (moment(this.innerPeriod.endOfPeriod, 'DD/MM/YYYY').isAfter(moment(this.endOfPeriod, 'DD/MM/YYYY'))) {
                    return false;
                }
                return true;
            },
            rangeOfPeriodRules() {
                return moment(this.innerPeriod.startOfPeriod, 'DD/MM/YYYY').isBefore(moment(this.innerPeriod.endOfPeriod, 'DD/MM/YYYY'));
            },
            incomeRules(){
                if (this.innerPeriod.employmentIncome < 0) {
                    return false;
                }
                if (this.innerPeriod.employmentIncome === "") {
                    return false;
                }
                return true;
            },
            endOfPeriod() {
                return this.getLoss('futureLossesEnd');
            }
        },
        methods: {
            ...mapActions('personal/claimant', [
                'updateIncomePeriodValue',
                'deleteIncomePeriod',
                'addIncomePeriod'
            ]),
            ...mapActions('modal', ['toggle']),
            updatePeriod() {
                this.$emit('update', {index: this.index, period: this.innerPeriod});
            },
            deletePeriod(){
                let maxIndex = this.maxIndex - 1;
                let prevIndex = this.index - 1;
                let nextIndex = this.index + 1;
                let nextPeriodEndOfPeriod = this.getIncomePeriod({ type: this.type, index: prevIndex }).endOfPeriod;
                let nextDay = moment(nextPeriodEndOfPeriod, 'DD/MM/YYYY').add(1, 'days').format('DD/MM/YYYY');

                (this.index === maxIndex) ? this.updateIncomePeriodValue({ type: this.type, index: prevIndex, key: 'endOfPeriod', value: this.endOfPeriod})
                    : this.updateIncomePeriodValue({ type: this.type, index: nextIndex, key: 'startOfPeriod', value: nextDay});

                this.deleteIncomePeriod({index: this.index, type: this.type});
            },
            updateNextPeriod() {
                let maxIndex = this.maxIndex - 1;
                this.updatePeriod();

                if (this.index < maxIndex) {
                    let nextIndex = this.index + 1;
                    let nextDay = moment(this.innerPeriod.endOfPeriod, 'DD/MM/YYYY').add(1, 'days').format('DD/MM/YYYY');

                    this.updateIncomePeriodValue({ type: this.type, index: nextIndex, key: 'startOfPeriod', value: nextDay});

                    for (let i = nextIndex, len = maxIndex; i <= len; i++) {
                        let prevPeriodEndOfPeriod = '';
                        let periodEndOfPeriod = '';
                        let periodStartOfPeriod = '';

                        prevPeriodEndOfPeriod = this.getIncomePeriod({ type: this.type, index: i - 1}).endOfPeriod;
                        periodEndOfPeriod = this.getIncomePeriod({ type: this.type, index: i }).endOfPeriod;
                        periodStartOfPeriod = this.getIncomePeriod({ type: this.type, index: i }).startOfPeriod;

                        if (prevPeriodEndOfPeriod > periodStartOfPeriod) {
                            periodStartOfPeriod = moment(prevPeriodEndOfPeriod, 'DD/MM/YYYY').format('DD/MM/YYYY');
                            this.updateIncomePeriodValue({ type: this.type, index: i, key: 'startOfPeriod', value: periodStartOfPeriod})
                        }

                        if (periodEndOfPeriod <= periodStartOfPeriod && i !== len) {
                            this.updateIncomePeriodValue({ type: this.type, index: i, key: 'endOfPeriod', value: periodStartOfPeriod})
                        }
                    }
                }

                if (moment(this.innerPeriod.endOfPeriod, 'DD/MM/YYYY').isBefore(moment(this.endOfPeriod, 'DD/MM/YYYY'))
                    && moment(this.innerPeriod.endOfPeriod, 'DD/MM/YYYY').isAfter(moment(this.innerPeriod.startOfPeriod, 'DD/MM/YYYY'))
                    && this.index === maxIndex) {
                    this.addIncomePeriod(this.type);
                }
            },
            openDialog() {
                if (!this.isModalOpen) {
                    this.nodes = [];
                    this.selectedNode = null;
                    this.selectedNodes = [];
                    return this.toggle('ons_salary_'+this.uniqueId).then(this.updateNodes);
                }
            },
            closeModal() {
                if (this.isModalOpen) {
                    return this.toggle('ons_salary_'+this.uniqueId);
                }
            },
            updateNodes(code = null) {
                this.loading = true;
                Api.calculators.ons.salary(this.gender, code)
                    .then(nodes => {
                        this.nodes = nodes;
                        this.loading = false;
                    });
            },
            selectNode(node) {
                if (node.code.length === 4) {
                    return;
                }
                this.selectedNode = node;
                this.selectedNodes.push(node);
                return this.updateNodes(node.code);
            },
            unselectNode(node) {
                let index = this.selectedNodes.indexOf(node);
                if (index === 0) {
                    this.selectedNodes = [];
                    this.selectedNode = null;
                    return this.updateNodes();
                }
                this.selectedNodes.splice(index);
                let lastIndex = this.selectedNodes.length - 1;
                this.selectedNode = this.selectedNodes[lastIndex];
                this.updateNodes(this.selectedNode.code);
            },
            selectSalary(node) {
                if (node === null) {
                    return Api.calculators.ons.averageSalary(this.claimant.gender)
                        .then(result => {
                            this.innerPeriod.employmentIncome = result.value;
                            this.innerPeriod.employmentNetGross = 'gross';
                            this.updatePeriod();
                        }).then(() => {
                            this.closeModal;
                            this.disabledNetGross = true;
                        });
                }
                this.innerPeriod.employmentIncome = node.salary;
                this.updatePeriod();
                this.closeModal();
            },
            displaySalary(node) {
                if (node.salary === "x") {
                    return "No Information";
                }
                return this.currencyFormat(node.salary, '£', 0);
            },
            getLastNode() {
                return this.selectedNodes.slice(-1)[0];
            }
        }
    }
</script>


// WEBPACK FOOTER //
// IncomePeriod.vue?1178c8f8